import { makeAutoObservable, runInAction } from "mobx";

export default class PlatformHistoryStore {
  platformHistory = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.platformHistory = [];
    runInAction(() => {
      this.platformHistory = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.platformHistory.filter((item) => item.id !== id);
    this.platformHistory = [];
    this.platformHistory = newState;
  };
}
